import {
  CrmConsentChannel,
  CrmConsentScope,
  CrmConsentSource,
  CrmContactPurpose,
  CrmContactStatus,
  CrmMailingListReason,
  CrmTaskStatus,
  CrmTaskType,
} from '../crm-contact';
import { validateEnumTranslations } from '../../safety_checks';

export const TRANSLATE_KEY_CRM_CONSENT_CHANNEL = 'CRM_CONSENT_CHANNEL_';
export const TRANSLATE_KEY_CRM_CONSENT_SCOPE = 'CRM_CONSENT_SCOPE_';
export const TRANSLATE_KEY_CRM_CONSENT_SOURCE = 'CRM_CONSENT_SOURCE_';
export const TRANSLATE_KEY_CRM_CONTACT_STATUS = 'CRM_CONTACT_STATUS_';
export const TRANSLATE_KEY_CRM_CONTACT_PURPOSE = 'CRM_CONTACT_PURPOSE_';
export const TRANSLATE_KEY_CRM_TASK_TYPE = 'CRM_TASK_TYPE_';
export const TRANSLATE_KEY_CRM_TASK_STATUS = 'CRM_TASK_STATUS_';
export const TRANSLATE_KEY_CRM_MAILING_LIST_REASON = 'CRM_MAILING_LIST_REASON_';

export const CrmConsentChannelTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_CRM_CONSENT_CHANNEL}${CrmConsentChannel.CALL}`]: 'Appels',
    [`${TRANSLATE_KEY_CRM_CONSENT_CHANNEL}${CrmConsentChannel.SMS}`]: 'SMS',
    [`${TRANSLATE_KEY_CRM_CONSENT_CHANNEL}${CrmConsentChannel.EMAIL}`]: 'Emails',
    [`${TRANSLATE_KEY_CRM_CONSENT_CHANNEL}${CrmConsentChannel.WHATSAPP}`]: 'WhatsApp',
    [`${TRANSLATE_KEY_CRM_CONSENT_CHANNEL}${CrmConsentChannel.ALL}`]: 'Tous les canaux',
  },
};

export const CrmConsentScopeTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_CRM_CONSENT_SCOPE}${CrmConsentScope.ALL}`]: 'Tout',
    [`${TRANSLATE_KEY_CRM_CONSENT_SCOPE}${CrmConsentScope.LIFECYCLE}`]: 'Relances et suivi',
    [`${TRANSLATE_KEY_CRM_CONSENT_SCOPE}${CrmConsentScope.PROSPECTION}`]: 'Liste de diffusion',
    [`${TRANSLATE_KEY_CRM_CONSENT_SCOPE}${CrmConsentScope.NEWSLETTER}`]: 'Newsletter clients',
  },
};

export const CrmConsentSourceTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_CRM_CONSENT_SOURCE}${CrmConsentSource.CSM_CALL}`]: 'Dit pendant un appel',
    [`${TRANSLATE_KEY_CRM_CONSENT_SOURCE}${CrmConsentSource.PULSE}`]: 'Écrit à Pulse',
    [`${TRANSLATE_KEY_CRM_CONSENT_SOURCE}${CrmConsentSource.SMS_STOP}`]: 'STOP reçu par SMS',
    [`${TRANSLATE_KEY_CRM_CONSENT_SOURCE}${CrmConsentSource.EMAIL_UNSUB}`]: 'Désabonnement depuis un email',
    [`${TRANSLATE_KEY_CRM_CONSENT_SOURCE}${CrmConsentSource.ACCOUNT_DELETION_REQUEST}`]:
      'Demande de suppression de compte',
    [`${TRANSLATE_KEY_CRM_CONSENT_SOURCE}${CrmConsentSource.PUBLIC_PAGE}`]: 'Page de réponse publique',
    [`${TRANSLATE_KEY_CRM_CONSENT_SOURCE}${CrmConsentSource.ADMIN}`]: 'Saisi par l’équipe',
  },
};

export const CrmContactStatusTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_CRM_CONTACT_STATUS}${CrmContactStatus.NORMAL}`]: 'Contact autorisé',
    [`${TRANSLATE_KEY_CRM_CONTACT_STATUS}${CrmContactStatus.DO_NOT_CALL}`]: 'Ne pas rappeler',
    [`${TRANSLATE_KEY_CRM_CONTACT_STATUS}${CrmContactStatus.UNSUBSCRIBED}`]: 'Désinscrit',
    [`${TRANSLATE_KEY_CRM_CONTACT_STATUS}${CrmContactStatus.DO_NOT_CONTACT}`]: 'Ne plus contacter',
  },
};

/** Libellés de « ce qui est coupé » dans le bandeau de non-contact. */
export const CrmContactPurposeTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_CRM_CONTACT_PURPOSE}${CrmContactPurpose.PULSE_RELANCE}`]: 'Relances Pulse',
    [`${TRANSLATE_KEY_CRM_CONTACT_PURPOSE}${CrmContactPurpose.PULSE_RELANCE_EMAIL}`]: 'Relances Pulse par email',
    [`${TRANSLATE_KEY_CRM_CONTACT_PURPOSE}${CrmContactPurpose.TRIAL_RELANCE_EMAIL}`]: 'Emails de relance d’essai',
    [`${TRANSLATE_KEY_CRM_CONTACT_PURPOSE}${CrmContactPurpose.TRIAL_RELANCE_SMS}`]: 'SMS de relance d’essai',
    [`${TRANSLATE_KEY_CRM_CONTACT_PURPOSE}${CrmContactPurpose.TRIAL_RELANCE_APP}`]: 'Notifications de relance d’essai',
    [`${TRANSLATE_KEY_CRM_CONTACT_PURPOSE}${CrmContactPurpose.QUEUE_CALL}`]: 'Appels de la file',
    [`${TRANSLATE_KEY_CRM_CONTACT_PURPOSE}${CrmContactPurpose.LAST_CHANCE_SMS}`]: 'SMS de dernière chance',
    [`${TRANSLATE_KEY_CRM_CONTACT_PURPOSE}${CrmContactPurpose.TRAINING_SMS}`]: 'SMS de suivi de formation',
    [`${TRANSLATE_KEY_CRM_CONTACT_PURPOSE}${CrmContactPurpose.SESSION_FOLLOWUP_EMAIL}`]: 'Emails de suite de séance',
    [`${TRANSLATE_KEY_CRM_CONTACT_PURPOSE}${CrmContactPurpose.PROSPECTION_EMAIL}`]: 'Emails de la liste de diffusion',
    [`${TRANSLATE_KEY_CRM_CONTACT_PURPOSE}${CrmContactPurpose.PROSPECTION_SMS}`]: 'SMS de la liste de diffusion',
    [`${TRANSLATE_KEY_CRM_CONTACT_PURPOSE}${CrmContactPurpose.NEWSLETTER_EMAIL}`]: 'Newsletter clients',
    [`${TRANSLATE_KEY_CRM_CONTACT_PURPOSE}${CrmContactPurpose.NEWSLETTER_SMS}`]: 'SMS aux clients',
  },
};

export const CrmTaskTypeTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_CRM_TASK_TYPE}${CrmTaskType.MANUAL}`]: 'Tâche',
    [`${TRANSLATE_KEY_CRM_TASK_TYPE}${CrmTaskType.ACCOUNT_DELETION}`]: 'Suppression de compte',
    [`${TRANSLATE_KEY_CRM_TASK_TYPE}${CrmTaskType.CONSENT_REVIEW}`]: 'Refus à vérifier',
  },
};

export const CrmTaskStatusTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_CRM_TASK_STATUS}${CrmTaskStatus.OPEN}`]: 'À faire',
    [`${TRANSLATE_KEY_CRM_TASK_STATUS}${CrmTaskStatus.DONE}`]: 'Faite',
    [`${TRANSLATE_KEY_CRM_TASK_STATUS}${CrmTaskStatus.CANCELLED}`]: 'Annulée',
  },
};

/** Pourquoi la personne est, ou n'est pas, dans une liste de diffusion. */
export const CrmMailingListReasonTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_CRM_MAILING_LIST_REASON}${CrmMailingListReason.LIFECYCLE}`]: 'Inscrite d’office (étape du suivi)',
    [`${TRANSLATE_KEY_CRM_MAILING_LIST_REASON}${CrmMailingListReason.MANUAL}`]: 'Ajoutée par l’équipe',
    [`${TRANSLATE_KEY_CRM_MAILING_LIST_REASON}${CrmMailingListReason.REFUSED}`]: 'Désinscrite',
    [`${TRANSLATE_KEY_CRM_MAILING_LIST_REASON}${CrmMailingListReason.NOT_ELIGIBLE}`]: 'Pas concernée par cette liste',
    [`${TRANSLATE_KEY_CRM_MAILING_LIST_REASON}${CrmMailingListReason.NO_EMAIL}`]: 'Pas d’adresse email',
  },
};

//DONT TOUCH below this line
validateEnumTranslations(CrmConsentChannel, CrmConsentChannelTranslation, TRANSLATE_KEY_CRM_CONSENT_CHANNEL, true);
validateEnumTranslations(CrmConsentScope, CrmConsentScopeTranslation, TRANSLATE_KEY_CRM_CONSENT_SCOPE, true);
validateEnumTranslations(CrmConsentSource, CrmConsentSourceTranslation, TRANSLATE_KEY_CRM_CONSENT_SOURCE, true);
validateEnumTranslations(CrmContactStatus, CrmContactStatusTranslation, TRANSLATE_KEY_CRM_CONTACT_STATUS, true);
validateEnumTranslations(CrmContactPurpose, CrmContactPurposeTranslation, TRANSLATE_KEY_CRM_CONTACT_PURPOSE, true);
validateEnumTranslations(CrmTaskType, CrmTaskTypeTranslation, TRANSLATE_KEY_CRM_TASK_TYPE, true);
validateEnumTranslations(CrmTaskStatus, CrmTaskStatusTranslation, TRANSLATE_KEY_CRM_TASK_STATUS, true);
validateEnumTranslations(
  CrmMailingListReason,
  CrmMailingListReasonTranslation,
  TRANSLATE_KEY_CRM_MAILING_LIST_REASON,
  true,
);
